import { render, staticRenderFns } from "./AuTreatmentHistory.vue?vue&type=template&id=f388759a&scoped=true&"
import script from "./AuTreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./AuTreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./AuTreatmentHistory.vue?vue&type=style&index=0&id=f388759a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f388759a",
  null
  
)

export default component.exports